<script>
    import { Howl } from 'howler';
    export let onRestart;

    $: isMusicPlaying = true;

    const music = new Howl({
        src: ['sounds/esbrent_lazar.mp3'],
        onend: () => { isMusicPlaying = false },
        html5: true
    });

    const onMusicButtonClick = () => {
        isMusicPlaying ? music.pause() : music.play();
        isMusicPlaying = !isMusicPlaying
    }

    const onRestartButtonClick = () => {
        onRestart();
        music.stop();
    }

    music.play();
</script>

<div class="media-player-container">
    <div class="restart-button-container" on:click={onRestartButtonClick}>
        <p class="button-label">restart</p>
        <img
            class="restart-button"
            src="images/extra_elements/borito.png"
            alt=""
        />
    </div>
    <img
        class="media-player-button"
        src={`images/extra_elements/${isMusicPlaying ? 'pause_button' : 'play_button'}.png`}
        alt=""
        on:click={onMusicButtonClick}
    />
</div>


<style>
    .media-player-container {
        position: absolute;
        bottom: 0px;
        left: 20px;

        display: flex;
        align-items: center;
    }
    .restart-button-container {
        cursor: pointer;
        margin: 0vw 2vw;
    }
    .restart-button {
        width: 4vw;
    }
    .media-player-button {
        width: 8vw;
        cursor: pointer;
        padding-top: 20px; /* hack... */
    }
    .button-label {
        font-size: 17px;
        color: white;
        text-align: center;
        margin: 0px;
    }
</style>